import { Service } from "../lib";

const PRODHOST = location.protocol == "https:" ? "https://xyapi.uzhutm.cn" : "http://xyapi.uzhutm.cn";

const createConfig = Service.createServiceFromHost({
    "DEV": "http://localhost:9000",
    "UAT": "",
    "SIT": "http://47.114.42.241:8083",
    "PROD": "http://kpjs-api.kxcbzx.com:9000",
    "KEJI": PRODHOST
});

export const ServiceConfig = createConfig({
    "env": APP_ENV,
    "host": {
        "DEV": "http://localhost:9000",
        "SIT": "http://47.114.42.241:8083",
        "PROD": "http://kpjs-api.kxcbzx.com:9000",
        "KEJI": PRODHOST
    },
    "config": {
        "login": {
            withCredentials: true,
            "endPoints": {
                "status": {
                    url: "/login/admin/status",
                    method: "GET"
                },
                "logout": {
                    url: "/login/logout",
                    method: "POST"
                },
                "captchaGenerate": {
                    url: "/login/captcha/generate",
                    method: "GET",
                    responseType: "blob"
                },
                "submit": {
                    url: "/login/submit",
                    method: "POST"
                },
                "loginByPhoneNumber": {
                    url: "/login/mobile/login/submit",
                    method: "POST"
                },
                "sendSMS": {
                    url: "/login/send/sms/{{phoneNumber}}",
                    method: "POST"
                },
                "config": {
                    url: "/login/config",
                    method: "GET"
                },
                "registe": {
                    url: "/login/registe",
                    method: "POST"
                },
                "webAuth": {
                    url: "/auth/status",
                    method: "GET"
                }
            }
        },
        "setting": {
            withCredentials: true,
            "endPoints": {
                "updateWebsite": {
                    url: "/admin/setting/update/website",
                    method: "POST"
                },
                "configWebsite": {
                    url: "/admin/setting/config/website",
                    method: "GET"
                },
                "configList": {
                    url: "/admin/setting/config/list",
                    method: "GET"
                },
                "configDelete": {
                    url: "/admin/setting/config/delete",
                    method: "DELETE"
                },
                "langaugeList": {
                    url: "/admin/language/list",
                    method: "POST"
                },
                "languageSubmit": {
                    url: "/admin/language/submit",
                    method: "POST"
                },
                "languageDelete": {
                    url: "/admin/language/delete",
                    method: "DELETE"
                },
                "uploadFile": {
                    url: "/admin/upload/file",
                    method: "POST",
                    header: {
                        'Content-Type': 'multipart/form-data'
                    }
                },
                "categorySubmit": {
                    url: "/admin/setting/option/submit",
                    method: "POST"
                },
                "regionList": {
                    url: "/admin/setting/region/list",
                    method: "GET"
                },
                "jsCityList": {
                    url: "/config/region/jscities",
                    method: "GET"
                }
            }
        },
        "menus": {
            withCredentials: true,
            endPoints: {
                "submit": {
                    url: "/menus/submit",
                    method: "POST"
                },
                "structList": {
                    url: "/menus/struct/list",
                    method: "POST"
                },
                "fullList": {
                    url: "/menus/struct/fullList",
                    method: "POST"
                },
                "list": {
                    url: "/menus/list",
                    method: "POST"
                },
                "delete": {
                    url: "/menus/delete",
                    method: "DELETE"
                },
                "listLimit": {
                    url: "/menus/limit/list",
                    method: "POST"
                }
            }
        },
        "user": {
            withCredentials: true,
            endPoints: {
                "list": {
                    url: "/admin/user/list",
                    method: "POST"
                },
                "update": {
                    url: "/admin/user/edit",
                    method: "POST"
                },
                "create": {
                    url: "/admin/user/create",
                    method: "POST"
                },
                "delete": {
                    url: "/user/delete",
                    method: "POST"
                },
                "status": {
                    url: "/admin/user/update/status",
                    method: "POST"
                },
                "groupList": {
                    url: "/admin/adgroup/list",
                    method: "GET"
                },
                "groupSubmit": {
                    url: "/admin/adgroup/submit",
                    method: "POST"
                },
                "moduleList": {
                    url: "/admin/adgroup/module/list",
                    method: "POST"
                },
                "groupAdd": {
                    url: "/auth/group/add",
                    method: "POST"
                },
                "groupUpdate": {
                    url: "/auth/group/edit",
                    method: "POST"
                },
                "groupDelete": {
                    url: "/auth/group/delete",
                    method: "POST"
                },
                "sendSmsNotify": {
                    url: "/admin/sms/notify/group/user",
                    method: "POST"
                },
                "sendSmsNotifyByUserId": {
                    url: "/admin/sms/notify/user",
                    method: "POST"
                },
                "pageRight": {
                    url: "/admin/user/page/right",
                    method: "GET"
                },
                "authPublisher": {
                    url: "/admin/user/auth/publisher",
                    method: "GET"
                },
                "authApprover": {
                    url: "/admin/user/auth/approver",
                    method: "GET"
                },
                "registeList": {
                    url: "/admin/user/registe/list",
                    method: "POST"
                },
                "registeApprove": {
                    url: "/admin/user/registe/approve",
                    method: "POST"
                },
                "updatePassword": {
                    url: "/admin/user/update/password",
                    method: "POST"
                },
                "deleteRetryLimit": {
                    url: "/login/retry/limit/release",
                    method: "POST"
                }
            }
        },
        "article": {
            withCredentials: true,
            endPoints: {
                "list": {
                    url: "/admin/article/list",
                    method: "POST"
                },
                "importList": {
                    url: "/admin/article/import/list",
                    method: "POST"
                },
                "config": {
                    url: "/admin/article/config",
                    method: "GET"
                },
                "submit": {
                    url: "/admin/article/submit",
                    method: "POST"
                },
                "approveList": {
                    url: "/admin/article/approve/list",
                    method: "POST"
                },
                "approveSubmit": {
                    url: "/admin/article/approve/submit",
                    method: "POST"
                }
            }
        },
        "resource": {
            withCredentials: true,
            endPoints: {
                "list": {
                    url: "/admin/resource/list",
                    method: "POST"
                },
                
                "submit": {
                    url: "/admin/resource/submit",
                    method: "POST"
                },
                "delete": {
                    url: "/admin/resource/delete",
                    method: "DELETE"
               },
               "specialListSubmit": {
                    url: "/admin/speciallist/submit",
                    method: "POST"
               },
               "speciallList": {
                    url: "/admin/speciallist/list",
                    method: "POST"
               },
               "importList": {
                    url: "/admin/speciallist/import/list",
                    method: "POST"
                },
               "upload": {
                    url: "/admin/upload/file",
                    method: "POST"
               },
               "uploadMerge": {
                    url: "/admin/upload/merge",
                    method: "POST"
               },
               "lawDocSubmit": {
                    url: "/admin/resource/lawdoc/submit",
                    method: "POST"
                },
                "lawDocList": {
                    url: "/admin/resource/lawdoc/list",
                    method: "POST"
                },
                "mediaUrl": {
                    url: "/resource/media",
                    method: "GET"
                },
                "schoolList": {
                    url: "/admin/school/list",
                    method: "POST"
                },
                "editSchool": {
                    url: "/admin/school/submit",
                    method: "POST"
                },
                "expertApproveList": {
                    url: "/admin/speciallist/approve/list",
                    method: "POST"
                },
                "expertApproveSubmit": {
                    url: "/admin/speciallist/approve/submit",
                    method: "POST"
                }
            }
        },
        "activity": {
            "withCredentials": true,
            "endPoints": {
                "submit": {
                    "url": "/admin/activity/submit",
                    "method": "POST"
                },
                "list": {
                    url: "/admin/activity/list",
                    "method": "POST"
                },
                
                "updateStatus": {
                    url: "/admin/activity/update/status",
                    method: "POST"
                },
                "updateResponse": {
                    url: "/admin/activity/update/response",
                    method: "POST"
                },
                "approveList": {
                    url: "/admin/activity/approve/list",
                    "method": "POST"
                },
                "approveSubmit": {
                    url: "/admin/activity/approve/submit",
                    method: "POST"
                },
                "applySubmit": {
                    url: "/admin/activity/apply/submit",
                    method: "POST"
                },
                "applyList": {
                    url: "/admin/activity/apply/list",
                    "method": "POST"
                },
                "applyWithdraw": {
                    url: "/admin/activity/apply/withdraw",
                    method: "POST"
                },
                "applyDelete": {
                    url: "/admin/activity/apply/delete",
                    method: "DELETE"
                },
                "approveApplyList": {
                    url: "/admin/activity/apply/approve/list",
                    method: "POST"
                },
                "applyDealwithUsers": {
                    url: "/admin/activity/apply/dealwith/users",
                    method: "GET"
                },
                "applyAuthUser": {
                    url: "/admin/activity/apply/auth/user",
                    method: "POST"
                },
                "applyStatus": {
                    url: "/admin/activity/apply/status",
                    method: "POST"
                },
                "applyUpdate": {
                    url: "/admin/activity/apply/update",
                    method: "POST"
                },
                "applyDetails": {
                    url:  "/admin/activity/apply/details/{id}",
                    method: "GET"
                }
            }
        },
        "lawdoc": {
            "withCredentials": true,
            "endPoints": {
                "approveList": {
                    url: "/admin/lawdoc/approve/list",
                    "method": "POST"
                },
                "approveSubmit": {
                    url: "/admin/lawdoc/approve/submit",
                    "method": "POST"
                }
            }
        },
        "carousel": {
            "withCredentials": true,
            "endPoints": {
                "submit": {
                    "url": "/admin/carousel/submit",
                    "method": "POST"
                },
                "list": {
                    url: "/admin/carousel/list",
                    "method": "POST"
                },
                "category": {
                    url: "/admin/carousel/category",
                    "method": "GET"
                },
                "delete": {
                    url: "/admin/carousel/delete",
                    method: "DELETE"
                }
            }
        },
        "web": {
            "withCredentials": true,
            "endPoints": {
                "dashboard": {
                    url: "/home/dashboard",
                    method: "GET"
                },
                "articleDetails": {
                    url: "/resource/article/{id}",
                    method: "GET",
                    header: {
                        "X-Device": "Admin"
                    }
                },
                "activityDetails": {
                    url: "/resource/activity/{id}",
                    method: "GET",
                    header: {
                        "X-Device": "Admin"
                    }
                },
                "lawdocDetails": {
                    url: "/resource/lawdoc/{id}",
                    method: "GET",
                    header: {
                        "X-Device": "Admin"
                    }
                },
                "expertDetails": {
                    url: "/resource/expert/{id}",
                    method: "GET",
                    header: {
                        "X-Device": "Admin"
                    }
                }
            }
        },
        "files": {
            "withCredentials": true,
            "endPoints": {
                "list": {
                    url: "/admin/files/list",
                    method: "POST"
                },
                "folders": {
                    url: "/admin/files/folders",
                    method: "GET"
                },
                "delete": {
                    url: "/admin/files/delete",
                    method: "DELETE"
                },
                "fileStatus": {
                    url: "/admin/files/fileStatus",
                    method: "GET"
                },
                "diskInfo": {
                    url: "/admin/files/disk/size",
                    method: "GET"
                }
            }
        },
        "xyarticle": {
            withCredentials: true,
            endPoints: {
                "news": {
                    url: "/admin/kjxy/news/list",
                    method: "POST"
                },
                "newsSubmit": {
                    url: "/admin/kjxy/news/submit",
                    method: "POST"
                }
            }
        },
        "kjxy": {
            withCredentials: true,
            endPoints: {
                "xySubmit": {
                    url: "/admin/kjxy/xy/submit",
                    method: "POST"
                },
                "xyList": {
                    url: "/admin/kjxy/xy/list",
                    method: "POST"
                },
                "xyOptionList": {
                    url: "/admin/kjxy/xy/option/list",
                    method: "POST"
                },
                "goodsStoreSubmit": {
                    url: "/admin/kjxy/goods/store/submit",
                    method: "POST"
                },
                "goodsStoreList": {
                    url: "/admin/kjxy/goods/store/list",
                    method: "POST"
                },
                "expertSubmit": {
                    url: "/admin/kjxy/expert/submit",
                    method: "POST"
                },
                "expertList": {
                    url: "/admin/kjxy/expert/list",
                    method: "POST"
                },
                "expertApplies": {
                    url: "/admin/kjxy/expert/apply/list",
                    method: "POST"
                },
                "updateExpertApplyStatus": {
                    url: "/admin/kjxy/expert/apply/status/update",
                    method: "PUT"
                },
                "singleDocReviews": {
                    url: "/web/kjxy/single/article",
                    method: "GET"
                },
                "deepSeek": {
                    url: "/deepseek/v1/completions",
                    method: "POST",
                }
            }
        }
    }
});
